<template>
    <div class="page hotel m-0">
        <div class="mb-2">
            <b-button variant="outline-primary" :to="{name: 'hoteles'}">... Volver</b-button>
        </div>
        <!-- {{ hotel }} -->
        <!-- Galeria -->
        <div class="header hotel-carousel position-relative mb-3">
            <!-- Flickity HTML init -->
            <flickity ref="flickity" :options="flickityOptions" class="gallery">
                <div class="gallery-cell" v-for="(imagen, index) in imagenes" :key="index">
                    <img class="gallery-cell-image flickity-lazyloaded flickity-lazyerror" :src="imagen">
                </div>
            </flickity>
        </div>

        <!-- Datos Hotel -->
        <div class="description mx-2">
            <!-- <main class="container"> -->
            <div class="row">
                <!-- <div class="col-md-8"> -->
                <div class="col-md-12">
                    <div class="hotel-header-left">
                        <div class="row">
                            <div class="col-md-8 pl-3 text-bold">
                                <h4>{{ hotel.hotel }}</h4>
                            </div>
                            <div class="col-md-4">
                                <b-btn variant="outline-secondary" class="mt-2" pill size="md"
                                    @click="$root.$hotelPrecios(hotel)"><i class="fas fa-search mr-1"></i>Turnos y Precios
                                </b-btn>
                            </div>
                        </div>
                        <div class="hotel-location text-primary">
                            <i class="fas fa-map-marker-alt mr-0"></i>
                            <!-- <img src="img/map-marker-icon.svg" alt="" />  -->
                            {{ hotel.zon }}  -  <small> {{ hotel.pobla }} </small>
                        </div>
                    </div>

                    <!-- Descripcion -->
                    <div class="hotel-description py-4 border-bottom">
                        <div class="text-justify" v-html="hotel.des"></div>
                    </div>

                    <!-- Servicios -->
                    <div class="services-hotel border-bottom" v-show="hotel.ser>''">
                        <h2>Servicios</h2>
                        <div class="text-justify" v-html="hotel.ser"></div>
                    </div>

                    <!-- <GmapMap ref="mapRef"/> -->
                    <!-- <div v-show="mapa[0].position.lat!=0">
                        <gmap-map
                            :center="{lat: mapa[0].position.lat, lng: mapa[0].position.lng}"
                            :zoom="16" style="width: 100%; height: 400px">
                            <gmap-marker
                                v-for="m in mapa" :key="m.id"
                                :position="{lat: m.position.lat, lng: m.position.lng}"
                                :clickable="true"
                                :draggable="true"
                                @click="center = m.position"
                                @mouseover="statusText = m.text"
                                @mouseout="statusText = null"
                            ></gmap-marker>

                            <div slot="visible">
                                <div style="bottom: 0; left: 0; background-color: #0000FF; color: white; position: absolute; z-index: 100">
                                {{statusText}}
                                </div>
                            </div>

                        </gmap-map>
                    </div> -->

                    <div class="mapa" style="height:400px;" v-if="hotel.mapa>''">
                        <mapaOL :mapa="mapa"/>
                    </div>


                </div>
            </div>
            <!-- </main> -->
        </div>

        <!-- Modal Precios -->
        <!-- <hotelPrecios></hotelPrecios> -->

    </div>
</template>

<script>

import Flickity from 'vue-flickity';
// import MapContainer from '@/components/MapContainer'
import mapaOL from '@/components/mapaOL'

export default {
    name: 'hotelInfo',

    components: {
        Flickity,
        //MapContainer,
        mapaOL,

    },
    data() {
        return {
            //titulo: "INFORMACIÓN HOTEL",

            listaImagen: [],

            flickityOptions: {
                autoPlay: true,
                initialIndex: 0,
                prevNextButtons: true,
                pageDots: true,
                freeScroll: true,
                wrapAround: true,
                draggable: false,
                adaptiveHeight: true,

            },

        }
    },
    created() {
        if (!this.hotel.hot || this.hotel.hot == undefined) this.$router.push('/hoteles');

        //console.log('*hotel_info.created',this.hotel.hot, this.mapa);
    },
    mounted() {
        //console.log('*hotel_info.mounted',this.hotel.hot, this.mapa);

    },
    computed: {
        hotel() {
            return this.$store.state.hoteles.hotel;
        },
        imagenes() {
            let A=[];
            /*this.hotel.imagenes.split(',').forEach(value => {
                A.push(this.$store.getters.hotel_imagen(value));
                //A.push(this.$store.dispatch('hotel_imagen2',value));
            });*/
            //console.log('**imagenesA', A);
            this.hotel.imagen.forEach(value => {
                A.push(this.$store.state.G.urlTMP + value);
            })
            return A;
        },
        // { id,position{lat,lng},lonLat,text}
        mapa() {
            let m=this.hotel.mapa.split(',');
            return {id:1, position:{ lat:Number(m[0]), lng:Number(m[1]) }, lonLat: [ Number(m[1]), Number(m[0]) ], text: this.hotel.hotel};
        },

    },
    methods: {
        async hotel_precios() {
            //await this.$store.dispatch('hotel_precios', this.hotel);
            //this.$bvModal.show("modal_hotelPrecios");
            await this.$root.$hotelPrecios(this.hotel);
        },
        //galeria
        next() {
            this.$refs.flickity.next();
        },
        prev() {
            this.$refs.flickity.previous();
        },

        onSlideStart() {
            this.sliding = true
        },
        onSlideEnd() {
            this.sliding = false
        },
    }
}
</script>